import { makePropertySelector } from 'store/utils';

const getPropertySelector = makePropertySelector('auth');

export const getAccountId = getPropertySelector('accountId');
export const getIsAuthenticated = getPropertySelector('isAuthenticated');
export const getIsSessionInvalid = getPropertySelector('isSessionInvalid');
